import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { Login, ForgotPassword, ClearAction, GetIpAddress, RecaptchaPermissionStart } from '../store/auth.actions';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ValidationUtil, VALIDATION_MESSAGES } from "../../utils/validation.util";
import { environment} from "../../../environments/environment"
@Component({
  selector: 'app-login-screen',
  templateUrl: './login-screen.component.html',
  styleUrls: ['./login-screen.component.scss']
})
export class LoginScreenComponent implements OnInit, OnDestroy {

  loginForm: FormGroup;
  showForgotPassword = false;
  showPassword: boolean;
  forgotPasswordForm;
  setNewPasswordform;
  email;
  showOtpScreen: boolean = false;
  emailFromForgetPassword: any;
  idFromForgotpassword: any;
  verifyEmail: any = '';
  verifyId: any = '';
  stopper$: Subject<any> = new Subject();
  configList: any[];
  ipAddress: string;
  showCaptcha: boolean = true;
  validationMsg = VALIDATION_MESSAGES;

  constructor(
    private fb: FormBuilder,
    public store: Store<AppState>,
    private route: ActivatedRoute,
  ) {
    this.showPassword = false;
    this.store.dispatch(new RecaptchaPermissionStart());
    /* this.loginForm = this.fb.group({
      email: ['', Validators.compose([
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
      ])],
      password: ['', Validators.required],
      gRecaptchaResponse: ['', Validators.required]
    }); */
  }

  ngOnInit() {
    this.store.dispatch(new ClearAction())
    this.forgotPasswordForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/)
        ]
      ]
    });
    this.store.select(state => state.auth.user.forgotPassword).subscribe((response) => {
      if (response && Object.keys(response).length) {
        this.showOtpScreen = true
        this.verifyEmail = response.email;
        this.verifyId = response.id;
      } else {
        this.showOtpScreen = false
      }
    });
    this.store.select(state => state.auth.configurations).pipe(takeUntil(this.stopper$)).subscribe((res) => {
      console.log(res, "res")
      if (Object.keys(res).length) {
        let value = res.value
        this.showCaptcha = (((value === "true") || (value === true))) ? true : false;
      }
      if (this.showCaptcha) {
        this.loginForm = this.fb.group({
          email: ['', [
            Validators.required,
            ValidationUtil.cannotBeBlank,
            this.emailValidator
            // Validators.pattern(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/)
          ]],
          password: ['', Validators.required],
          gRecaptchaResponse: ['', Validators.required]
        });
      } else {
        this.loginForm = this.fb.group({
          email: ['', [
            Validators.required,
            ValidationUtil.cannotBeBlank,
            this.emailValidator
            // Validators.pattern(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/)
          ]],
          password: ['', Validators.required],
        })
      }
    })
  }

  login() {
    console.log(this.loginForm.invalid);
    if (this.loginForm.invalid) {
      return false;
    }

    const formDetails = this.loginForm.value;
    // this.store.dispatch(new GetIpAddress());
    // this.store.select(state => state.auth.user.ipAddress).subscribe(response => {
    //     if (response) {
    // if (Object.keys(response).length) {
    // this.ipAddress = response.ip;
    const payload = {
      'email': formDetails.email.trim(),
      'password': formDetails.password,
      // 'ip': this.ipAddress
    };
    // }
    // }
    // })

    if (this.showCaptcha) {
      payload['g-recaptcha-response'] = formDetails.gRecaptchaResponse;
    }
    this.store.dispatch(new Login(payload));
  }

  forgotPassword() {
    if (this.forgotPasswordForm.invalid) {
      return false;
    }
    this.email = this.forgotPasswordForm.value.email;
    // this.store.dispatch(new ForgotPassword(this.email));

    this.store.dispatch(new ForgotPassword(this.email));
    this.store.dispatch(new ClearAction())
    this.store.select(state => state.auth.user.backToLogin).subscribe(flag => {
      if (flag) {
        this.showOtpScreen = false;
        this.showForgotPassword = false;
        this.forgotPasswordForm.reset();
      }
    });
  }

  showPasswordFunction() {
    this.showPassword = !this.showPassword;
  }

  emailValidator(control: AbstractControl): { [key: string]: any } | null {
    const valid = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(control.value.trim())
    return valid
      ? null
      : { invalidEmail: { valid: false, value: control.value } }
  }

  ngOnDestroy() {
    this.stopper$.next();
    this.stopper$.complete();
  }

  changeTabFn($event) {
    if ($event.index == 1) {
      window.open(`${environment.download_template}/v2`, "_self");
    }
  }
}
